import { ValueFormatterFunc } from 'ag-grid-community'
import { formatIsoDateOnly, formatTimestamp } from './date'
import { formatUser } from './user'
import { Option } from '../models/general'

export const dateOnlyFormatter: ValueFormatterFunc = ({ value }) =>
  formatIsoDateOnly(value)

export const dateTimeFormatter: ValueFormatterFunc = ({ value }) =>
  formatTimestamp(value)

export const userFormatter: ValueFormatterFunc = ({ value }) =>
  formatUser(value)

type OptionLookup = Readonly<Record<string, Option>>

type GetOptionsArg = OptionLookup | readonly Option[]

const getLookupMap = (options: GetOptionsArg): OptionLookup => {
  if (Array.isArray(options)) {
    const lookup: Record<string, Option> = {}
    options.forEach(option => {
      lookup[option.value] = option
    })
    return lookup
  } else {
    return options as OptionLookup
  }
}

export const getOptionsFormatter = (options: GetOptionsArg): ValueFormatterFunc => {
  const optionsByValue = getLookupMap(options)
  return ({ value }): string => optionsByValue[value]?.display ?? ''
}

export const booleanOptions: Readonly<Record<'true' | 'false', Option<boolean>>> = {
  true: { display: 'Yes', value: true },
  false: { display: 'No', value: false },
}

export const booleanFormatter: ValueFormatterFunc = ({ value }): string => {
  if (typeof value == 'boolean') {
    return booleanOptions[value ? 'true' : 'false'].display
  } else {
    return ''
  }
}
